import { render, staticRenderFns } from "./DialogoCarga.vue?vue&type=template&id=a5c677fc&"
import script from "./DialogoCarga.vue?vue&type=script&lang=js&"
export * from "./DialogoCarga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports